import type { Locale } from '@st/i18n';
import { useTranslation } from '../i18n/I18nProvider';
import { cx } from '../lib/cx';

const LABEL: Record<Locale, string> = { hr: 'HR', en: 'EN' };

export function LanguageSwitch({
  onChange,
  className,
}: {
  onChange?: (l: Locale) => void;
  className?: string;
}) {
  const { locale, locales, setLocale, t } = useTranslation();
  return (
    <div className={cx('inline-flex rounded-pill border border-line p-0.5', className)}>
      <span className="sr-only" id="lang-label">
        {t('shell.language')}
      </span>
      {locales.map((l) => (
        <button
          key={l}
          type="button"
          aria-pressed={l === locale}
          aria-describedby="lang-label"
          onClick={() => {
            setLocale(l);
            onChange?.(l);
          }}
          className={cx(
            'rounded-pill px-3 py-1 text-[12px] tracking-[0.3px] transition-colors',
            l === locale ? 'bg-accent-dark text-surface' : 'text-ink-muted hover:text-ink',
          )}
        >
          {LABEL[l]}
        </button>
      ))}
    </div>
  );
}
